{
    "up.common.cancel": "キャンセル",
    "up.common.confirm": "確認",
    "up.common.start": "開始",
    "up.common.end": "終了",
    "up.common.stop": "停止",
    "up.common.copy": "コピー",
    "up.common.none": "なし",
    "up.common.tip": "ヒント",
    "up.common.success": "成功",
    "up.common.fail": "失敗",
    "up.common.close": "閉じる",
    "up.common.preview": "プレビュー",
    "up.common.re-select": "再選択",
    "up.common.rotate": "回転",
    "up.common.pleaseChoose": "選択してください",
    "up.common.loading": "読み込み中",
    "up.common.loading2": "読み込み中",
    "up.common.inOperation": "操作中",
    "up.common.settings": "設定",
    "up.common.retry": "再試行",
    "up.common.search": "検索",
    "up.common.more": "もっと見る",
    "up.common.video": "ビデオ",
    "up.common.file": "ファイル",
    "up.week.one": "月",
    "up.week.two": "火",
    "up.week.three": "水",
    "up.week.four": "木",
    "up.week.five": "金",
    "up.week.six": "土",
    "up.week.seven": "日",
    "up.barcode.error": "バーコードの生成に失敗しました",
    "up.calendar.chooseDates": "日付選択",
    "up.calendar.disabled": "この日付は無効です",
    "up.calendar.daysExceed": "選択日数は{days}日を超えることはできません",
    "up.cityLocate.locateCity": "都市の位置を特定",
    "up.cityLocate.fail": "位置特定に失敗しました。再試行するにはクリックしてください。",
    "up.cityLocate.locating": "位置特定中",
    "up.code.send": "認証コードを取得",
    "up.code.resendAfter": "X秒後に再送信",
    "up.code.resend": "再送信",
    "up.cropper.emptyWidhtOrHeight": "切り抜き枠の幅または高さが設定されていません",
    "up.empty.car": "ショッピングカートは空です",
    "up.empty.page": "ページが存在しません",
    "up.empty.search": "検索結果がありません",
    "up.empty.address": "配送先住所がありません",
    "up.empty.wifi": "Wi-Fiがありません",
    "up.empty.order": "注文がありません",
    "up.empty.coupon": "クーポンがありません",
    "up.empty.favor": "お気に入りがありません",
    "up.empty.permission": "権限がありません",
    "up.empty.history": "履歴がありません",
    "up.empty.news": "ニュースがありません",
    "up.empty.message": "メッセージがありません",
    "up.empty.list": "リストが空です",
    "up.empty.data": "データがありません",
    "up.empty.comment": "コメントがありません",
    "up.link.copyed": "リンクがコピーされました。ブラウザで開いてください",
    "up.loadmoe.loadmore": "さらに読み込む",
    "up.loadmoe.nomore": "これ以上データがありません",
    "up.noNetwork.text": "ネットワーク信号が失われました",
    "up.noNetwork.pleaseCheck": "ネットワークを確認するか、移動してください",
    "up.noNetwork.connect": "ネットワーク接続済み",
    "up.noNetwork.disconnect": "ネットワーク未接続",
    "up.pagination.previous": "前へ",
    "up.pagination.next": "次へ",
    "up.pullRefresh.pull": "引き下げて更新",
    "up.pullRefresh.release": "指を離して更新",
    "up.pullRefresh.refreshing": "更新中",
    "up.readMore.expand": "全文表示",
    "up.readMore.fold": "折りたたむ",
    "up.search.placeholder": "キーワードを入力してください",
    "up.signature.penSize": "線の太さ",
    "up.signature.penColor": "線の色",
    "up.upload.sizeExceed": "サイズ制限を超えています",
    "up.upload.uploading": "アップロード中",
    "up.upload.previewImageFail": "画像プレビュー失敗",
    "up.upload.previewVideoFail": "ビデオプレビュー失敗",
    "up.goodsSku.stock": "在庫",
    "up.goodsSku.price": "価格",
    "up.goodsSku.amount": "個",
    "up.goodsSku.choosed": "選択済み",
    "up.goodsSku.buyAmount": "購入数量"
}
